import styled from '@emotion/styled';

import theme from 'theme';
import {SizeTokenValue} from 'common';
import {CloseIcon} from 'icons';

import type {MouseEventHandler} from 'react';

import type {ChipProps} from '../types';

export const Button = styled.button`
  flex-shrink: 0;
  padding: 0;
  border: 0;
  outline: none;
  background: none;
  cursor: pointer;
  border-radius: 4px;
  line-height: 0;
  color: ${theme.colors.grey[60]};

  :hover {
    color: ${theme.colors.grey[80]};
  }

  :active {
    color: ${theme.colors.grey[60]};
  }
`;

export const EndAdornment: React.FC<ChipProps> = props => {
  const {onDelete, disabled, endAdornment = null} = props;

  if (onDelete && !disabled) {
    const onClick: MouseEventHandler = e => {
      e.preventDefault();
      e.stopPropagation();

      onDelete();
    };

    return (
      <>
        {endAdornment}
        <Button type="button" onClickCapture={onClick}>
          <CloseIcon size={SizeTokenValue.Small} />
        </Button>
      </>
    );
  }

  return endAdornment;
};
